module.exports = __webpack_public_path__ + "static/media/24WingChunAcademyLR-277.76a53308.jpg";